import { render, staticRenderFns } from "./summary-block.vue?vue&type=template&id=8f8d1d00&scoped=true"
import script from "./summary-block.vue?vue&type=script&lang=js"
export * from "./summary-block.vue?vue&type=script&lang=js"
import style0 from "./summary-block.vue?vue&type=style&index=0&id=8f8d1d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8d1d00",
  null
  
)

export default component.exports